import CustomLocalStore from './store'
export const customLocalStore = new CustomLocalStore()
